// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34DAH","colMin":"styles_colMin__2-n7k"};